import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';
import { MaterialImportsModule } from 'src/app/material-imports.module';

@Component({
  selector: 'app-pagination-filter-page-size',
  templateUrl: './pagination-filter-page-size.component.html',
  styleUrls: ['./pagination-filter-page-size.component.scss'],
  imports: [ MaterialImportsModule, MatOptionModule,]
})
export class PaginationFilterPageSizeComponent  {
  private _selectedPageSize = 8;

  @Input()
  public pageSizes = [4, 8, 16, 32, 64, 128];

  @Input()
  public set selectedPageSize(value: number) {
    this._selectedPageSize = value;

    this.updatePaginationPageSizeUI();
  }

  public get selectedPageSize(): number {
    return this._selectedPageSize;
  }


  @Input()
  public optionsSuffix  = 'per page';

  protected selectedPageSizeLabel = '';

  @Output() public callbackFunction: EventEmitter<number> = new EventEmitter();

  constructor() { }

  protected filterPaginationPageSize(event: MatSelectChange) {
    this.selectedPageSize = event.value;
    this.updatePaginationPageSizeUI();
    this.callbackFunction.emit(this.selectedPageSize);
  }

  private updatePaginationPageSizeUI() {
    if (this.selectedPageSize === -1) {
      this.selectedPageSizeLabel = `All`;
    } else {
      this.selectedPageSizeLabel = `${this.selectedPageSize} per page`;
    }
  }
}
